// =============================================================================
// GOUVERNANCE - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Le rendu historique est conservé dans _GouvDashboardLegacy.jsx pour
// référence. Le contenu est extrait en 5 widgets dans
// frontend/src/widgets/governance/, catalogués côté serveur et résolus
// via la cascade dashboard_layouts.
// =============================================================================
import DashboardGrid from "../../../components/dashboard/DashboardGrid";

export default function GouvDashboard() {
  return (
    <DashboardGrid hub="governance" title="Dashboard Gouvernance" />
  );
}
